import waves from "@/assets/cta-waves.svg";
import Reveal from "@/components/Reveal";
import { APP_URL } from "@/lib/config";

interface CtaBannerProps {
    heading?: string;
    ctaHref?: string;
    /** Override the heading classes (e.g. to match a page's unified heading scale). */
    headingClassName?: string;
}

const CtaBanner = ({
    heading = "Join 5k+ happy customers. Start your free trial",
    ctaHref = APP_URL,
    headingClassName = "max-w-2xl text-2xl font-bold sm:text-3xl md:text-4xl lg:text-5xl text-secondary-foreground",
}: CtaBannerProps) => {
    return (
        <section className="py-12">
            <div className="container mx-auto px-6 sm:px-8 md:px-[10%]">
                <Reveal variant="scale-in">
                    <div className="relative overflow-hidden rounded-3xl bg-accent p-6 sm:p-10 md:p-12">
                        <img
                            src={waves}
                            alt=""
                            role="presentation"
                            aria-hidden="true"
                            className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-30"
                        />
                        <div className="relative z-10">
                            <h2 className={headingClassName}>
                                {heading}
                            </h2>
                            <a
                                href={ctaHref}
                                className="mt-6 sm:mt-10 rounded-2xl bg-background px-6 sm:px-8 py-3 sm:py-4 text-sm sm:text-base font-medium text-foreground transition-all hover:opacity-90 inline-block"
                            >
                                Get started for free
                            </a>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
};

export default CtaBanner;
